var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.443137 0 0 0 0 0.776471 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_black",
    transform: "translate(-1182.000000, -221.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1182.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 58 0 58 58 0 58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2901024,13.7341676 C43.3435722,12.7876375 41.814562,12.7876375 40.8680319,13.7341676 L29,25.5779295 L17.1319681,13.7098976 C16.185438,12.7633675 14.6564278,12.7633675 13.7098976,13.7098976 C12.7633675,14.6564278 12.7633675,16.185438 13.7098976,17.1319681 L25.5779295,29 L13.7098976,40.8680319 C12.7633675,41.814562 12.7633675,43.3435722 13.7098976,44.2901024 C14.6564278,45.2366325 16.185438,45.2366325 17.1319681,44.2901024 L29,32.4220705 L40.8680319,44.2901024 C41.814562,45.2366325 43.3435722,45.2366325 44.2901024,44.2901024 C45.2366325,43.3435722 45.2366325,41.814562 44.2901024,40.8680319 L32.4220705,29 L44.2901024,17.1319681 C45.2123625,16.209708 45.2123625,14.6564278 44.2901024,13.7341676 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.bf950784455ac4a51d809168638043e7.svg";
export { ForwardRef as ReactComponent };